import get from 'transmute/get';
export const getTileBackgroundColor = get('tileBackgroundColor');
export const getTileBorderColor = get('tileBorderColor');